module.exports = __webpack_public_path__ + "static/media/7.7ff210ac.jpg";